import { render, staticRenderFns } from "./CompraDiretaUploadArquivo.vue?vue&type=template&id=30646b26&scoped=true"
import script from "./CompraDiretaUploadArquivo.vue?vue&type=script&lang=js"
export * from "./CompraDiretaUploadArquivo.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaUploadArquivo.vue?vue&type=style&index=0&id=30646b26&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30646b26",
  null
  
)

export default component.exports